const getParentOrigin = () => {
  try {
    return window.parent.location.origin;
  } catch (error) {
    if (window.location.ancestorOrigins?.length) {
      return window.location.ancestorOrigins[0];
    }

    // Firefox and IE don't have an equivalent to ancestorOrigins.
    return null;
  }
};

const getOrigin = (url) => url.match(/^https?:\/\/[^#?/]+/)[0];
const getHostname = (url) => new URL(url).hostname;

const removeSubdomain = (hostname) => {
  const parts = hostname.split('.');
  return parts.length < 3 ? hostname : parts.slice(1).join('.');
};

/**
 * Compares the parent origin with the target origin
 * and prevents the default behavior if they are different
 * @param {*} event the click event that can be prevented
 * @param {*} targetUrl the backUrl or an alternative url
 * @returns the target origin if it is valid, otherwise null
 */
export const checkOrigin = (event, targetUrl) => {
  if (!targetUrl) {
    event.preventDefault();
    event.stopPropagation();
    return null;
  }

  const targetHostname = getHostname(targetUrl);
  const parentHostname = getHostname(getParentOrigin() || targetUrl);

  const targetOrigin = removeSubdomain(targetHostname);
  const parentOrigin = removeSubdomain(parentHostname);

  if (parentOrigin !== targetOrigin) {
    event.preventDefault();
    event.stopPropagation();
    return null;
  }

  return getOrigin(targetUrl);
};
